// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"TreeItemTitle_titleContainer__1PfWX","title":"TreeItemTitle_title__1SZuF","subtitle":"TreeItemTitle_subtitle__2MctF"};